import { Section } from '../../sections/builders/section_builder';
import { ITermSectionTypesDatasource } from '../../term_courses/datasources/term_section_types_datasource';
import { SectionRegistrationServant } from './section_registration_servant';
import { ISection } from '../../../interfaces/scheduler_interfaces';
import * as _4 from 'lodash4';
import { MultiSectionServant } from './multi_section_servant';

export class CrossCourseLinkedSectionServant {
  constructor(
    private appConfigModel: any,
    private ngTermSectionTypesDatasource: ITermSectionTypesDatasource,
    private ngMultiSectionServant: MultiSectionServant
  ) {}

  // Returns an array of section Ids that are linked by sections
  getSectionIdOfLinkedCrossCourses(sectionId: number, allSections: ISection[]) {
    return SectionRegistrationServant.getSectionIdOfLinkedCrossCourses(
      sectionId,
      allSections,
      this.ngTermSectionTypesDatasource.values()
    );
  }

  getSectionsByIds(sectionIds: number[], allSections: ISection[]) {
    return _4.compact(_4.map(sectionIds, (sectionId: number) => _4.find(allSections, { id: sectionId })));
  }

  allSectionsAndSiblingsScheduled(sectionIds: number[], allSections: ISection[]) {
    return SectionRegistrationServant.allSectionsAndSiblingsScheduled(sectionIds, allSections);
  }

  // Given an array of section ids, will return html markup of sections
  getDropModalText(sectionId: number[], allSections: ISection[]) {
    const sectionLabel = this.appConfigModel.model.member_configs['section_label'] || 'Section';

    return _4.reduce(
      sectionId,
      (sum, section) => {
        const sectionObj = _4.find(allSections, { id: section });
        if (_4.isUndefined(sectionObj)) {
          return sum;
        }
        const courseTitle = _4.get(sectionObj, '_course.cd', '') + _4.get(sectionObj, '_course.title', '');
        const crn = _4.get(sectionObj, 'cd', '');
        return (sum += `<div>debug(section: ${sectionObj.id}) ${courseTitle} (${sectionLabel} ${crn})</div>`);
      },
      `<div></div>`
    );
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/course_scheduler/servants/cross_course_linked_section_servant.ts